// extracted by css-extract-rspack-plugin
export default {"priceCellHeight":"_b6844e87"};